import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import ChartTemplate from '@blade/common/components/echart-template/index.vue';
let default_1 = class extends Vue {
    gaugeConfig = {
        type: 'gauge',
        data: {
            value: 10,
            ceil: '%',
            text: 'Male',
        },
        clockwise: true,
        isLine: true,
    };
    gaugeRightConfig = {
        type: 'gauge',
        data: {
            value: 10,
            ceil: '%',
            text: 'Female',
        },
        clockwise: false,
        // axisLineColor: 'red',
        processColor: 'green',
        isLine: true,
    };
    pieConfig = {
        type: 'pie',
        data: [
            {
                value: 10,
                name: 'a',
            },
            {
                value: 20,
                name: 'b',
            },
        ],
    };
    lineConfig = {
        type: 'line',
        xAxisData: ['a', 'b', 'c'],
        series: [
            { name: '图例1', type: 'line', data: [1, 2, 3] },
            { name: '图例2', type: 'line', data: [3, 1, 2] },
            { name: '图例3', type: 'line', data: [2, 1, 3] },
        ],
        isDataZoom: true,
    };
    mounted() {
        setInterval(() => {
            this.gaugeConfig.data.value = Math.ceil(100 * Math.random());
            this.gaugeRightConfig.data.value = Math.ceil(100 * Math.random());
            this.pieConfig.data[0].value = Math.ceil(100 * Math.random());
            this.pieConfig.data[1].value = Math.ceil(100 * Math.random());
            this.lineConfig.series.forEach((item) => {
                item.data = [Math.ceil(100 * Math.random()), Math.ceil(100 * Math.random()), Math.ceil(100 * Math.random())];
            });
        }, 3000);
    }
};
default_1 = __decorate([
    Component({
        components: { ChartTemplate },
    })
], default_1);
export default default_1;
